<template>
  <div>
    <v-container>
      <v-btn
        depressed
        @click="graphtype = 'user'"
        :outline="graphtype != 'user'"
        :color="graphtype == 'user' ? 'primary' : 'grey'"
      >
        {{ $t('User') }}
      </v-btn>
      <v-btn
        depressed
        @click="graphtype = 'message'"
        :outline="graphtype != 'message'"
        :color="graphtype == 'message' ? 'primary' : 'grey'"
      >
        {{ $t('Message') }}
      </v-btn>
    </v-container>
    <v-divider />
    <template v-if="type == 'comment'">
      <v-container>
        <select-page-post
          v-model="selectedPost"
          @resetSelectPost="resetSelectPost"
          @changePost="onChangePost"
        ></select-page-post>
      </v-container>
      <v-divider></v-divider>
    </template>
    <v-container v-if="type == 'inbox' || type == 'comment'">
      <v-layout>
        <v-flex>
          <select-channel
            v-model="app"
            @changeChannel="loadData"
            :type=type
          ></select-channel>
        </v-flex>
        <v-flex shrink>
          <v-btn
            v-if="$store.getters.getPackage != 'premium'"
            outline
            color="grey"
            class="ma-0 mb-1"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
            <v-premium-lock
              text="Bring the data to excel for analysis. Upgrade to Premium onwards, starting at 500 baht/month."
            ></v-premium-lock>
          </v-btn>
          <v-btn
            v-else-if="$store.getters.getPackage == 'premium'"
            @click="exportdata(graphtype)"
            :loading="!dataExportDate && !dataExportTime"
            color="primary"
            outline
            class="ma-0 mb-1"
          >
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <date-filter
        v-model="selectedDate"
        @changeDate="onDateChanged"
        :default-filter="'last_7_days'"
        :itemsHide="['this_year', 'last_365_day']"
      ></date-filter>

      <template v-if="graphtype == 'user'">
        <report-user-by-date
          :key="`report-user-by-date_${timestamp}`"
          :type="type"
          :date="selectedDate"
          :app="app"
          :fbpost="selectedPost"
          v-model="dataExportDate"
        ></report-user-by-date>

        <report-user-by-time
          :key="`report-user-by-time_${timestamp}`"
          :type="type"
          :date="selectedDate"
          :app="app"
          :fbpost="selectedPost"
          v-model="dataExportTime"
        ></report-user-by-time>
      </template>
      <template v-else-if="graphtype == 'message'">
        <report-message
          :key="`report-message_${timestamp}`"
          :type="type"
          :date="selectedDate"
          :app="app"
          :fbpost="selectedPost"
        ></report-message>
      </template>
    </v-container>
  </div>
</template>

<script>
import SelectChannel from './SelectChannel'
import DateFilter from './DateFilter'
import dayjs from 'dayjs'
import ReportUserByDate from './ReportUserByDate'
import ReportUserByTime from './ReportUserByTime'
import ReportMessage from './ReportMessage'
import SelectPagePost from './SelectPagePost'
import XLSX from 'xlsx'
import { mapGetters } from 'vuex'

export default {
  props: ['type'],
  data() {
    return {
      graphtype: 'user',
      selectedPost: null,
      app: 'all',
      selectedDate: {
        start: dayjs()
          .subtract(7, 'days')
          .format('YYYY-MM-DD'),
        end: dayjs().format('YYYY-MM-DD')
      },
      timestamp: dayjs().format('x'),
      dataExportDate: null,
      dataExportTime: null
    }
  },
  computed: {
    ...mapGetters({
      reportInboxMessage: 'getReportInboxMessage',
      reportReplyToComment: 'getReportReplyToComment',
      reportReplyToInbox: 'getReportReplyToInbox',
      reportHideToComment: 'getReportHideToComment'
    })
  },
  components: {
    SelectChannel,
    DateFilter,
    ReportUserByDate,
    ReportUserByTime,
    ReportMessage,
    SelectPagePost
  },
  methods: {
    onChangePost() {
      this.timestamp = dayjs().format('x')
    },
    resetSelectPost() {
      this.selectedPost = null
      this.onChangePost()
    },
    loadData() {},
    fetchData() {},
    onDateChanged() {},
    exportdata(graphtype) {
      var json = []
      var timeData = []
      const wb = XLSX.utils.book_new()
      if (this.type === 'inbox') {
        if (graphtype === 'message') {
          var name = 'inbox-message.xlsx'
          json = this.reportInboxMessage.data
          const ws = XLSX.utils.json_to_sheet(json)
          wb.SheetNames.push('inbox-message')
          wb.Sheets['inbox-message'] = ws
        } else if (graphtype === 'user') {
          Object.keys(this.dataExportTime[0]).map(item => {
            timeData.push({ time: item, message: this.dataExportTime[0][item] })
          })
          json = this.dataExportDate
          var name = 'inbox-user.xlsx'

          wb.SheetNames.push('export-by-date')
          wb.SheetNames.push('exprot-by-time')
          var ws = XLSX.utils.json_to_sheet(json)
          var ws2 = XLSX.utils.json_to_sheet(timeData)
          wb.Sheets['export-by-date'] = ws
          wb.Sheets['exprot-by-time'] = ws2
        }
      } else if (this.type === 'comment') {
        if (graphtype === 'message') {
          var name = 'comment-message.xlsx'
          wb.SheetNames.push('reply-to-date')
          wb.SheetNames.push('reply-to-inbox')
          wb.SheetNames.push('hide-to-comment')
          var ws = XLSX.utils.json_to_sheet(this.reportReplyToInbox.data)
          var ws2 = XLSX.utils.json_to_sheet(this.reportReplyToComment.data)
          var ws3 = XLSX.utils.json_to_sheet(this.reportHideToComment.data)
          wb.Sheets['reply-to-date'] = ws
          wb.Sheets['reply-to-inbox'] = ws2
          wb.Sheets['hide-to-comment'] = ws3
        } else if (graphtype === 'user') {
          Object.keys(this.dataExportTime[0]).map(item => {
            timeData.push({ time: item, message: this.dataExportTime[0][item] })
          })
          json = this.dataExportDate
          var name = 'comment-user.xlsx'
          wb.SheetNames.push('export-by-date')
          wb.SheetNames.push('exprot-by-time')
          var ws = XLSX.utils.json_to_sheet(json)
          var ws2 = XLSX.utils.json_to_sheet(timeData)
          wb.Sheets['export-by-date'] = ws
          wb.Sheets['exprot-by-time'] = ws2
        }
      }
      XLSX.writeFile(wb, name)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/ReportConversation.vue